// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__aD7za","label":"Completed_label__2ieUa"};